import React from 'react'
import classNames from 'classnames'
import { formatDate } from '@apiEnabler/ob-common/lib/date-utils'
import StatusIcon from './StatusIcon'
import format from '@apiEnabler/ob-common/lib/currency-formatter'
import style from './HistoryCard.module.css'

const RESPONSE_LABELS = {
  true: 'Yes',
  false: 'No',
}

export default function HistoryCard({
  className,
  history,
  showIcon = true,
  isBalanceTransfer,
}) {
  const isBalanceTransferSucceededOrFailed =
    isBalanceTransfer &&
    (history.status === 'SUCCEEDED' || history.status === 'FAILED')
  return (
    <div className={classNames(style.card, className)}>
      <div className={style.content}>
        <div className={style.status}>
          <div className={`${style.statusLabel} js-history-label`}>
            {history.label !== '-'
              ? history.label
              : `Funds available: ${
                  RESPONSE_LABELS[history.isAmountAvailable]
                } ${format(history.currency, history.amount)}`}
          </div>
          {showIcon && (
            <StatusIcon
              status={history.status}
              className={style.statusIcon}
              isHistory
            />
          )}
        </div>
        <div className={style.details}>
          {history.reference && (
            <div className={`${style.reference} js-history-reference`}>
              Ref: {history.reference}
            </div>
          )}
          {!isBalanceTransferSucceededOrFailed && history.date && (
            <div className={`${style.date} js-history-date`}>
              {formatDate(history.date, 'DD MMMM YYYY [at] HH:mm')}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
